import { Grid2, Stack, Typography, Box, Button, Divider, OutlinedInput, FormControl, FormHelperText } from '@mui/material'
import logo from '../logo.png';
import HeroImage from '../iPhone_12.png';
import '../App.css';
import Header from '../layout/MinimalLayout/Header';
import Footer from '../layout/MinimalLayout/Footer';
import useMediaQuery from '@mui/material/useMediaQuery';


const Accueil = () => {
  const isMobile = useMediaQuery('(max-width: 800px)');
  const isL = useMediaQuery('(max-width: 1050px)');
  const isM = useMediaQuery('(max-width: 800px)');
  const isS = useMediaQuery('(max-width: 600px)');
  const isXS = useMediaQuery('(max-width: 450px)');
    return (
        <Box className="App" sx={{ display: 'flex', flexDirection: 'column', backgroundColor: "#F8F9F9", height: 'auto', minHeight: '100vh', justifyContent:'center' }}>
          <Header />
          <Grid2 container sx={{ flexDirection: isL ? "column-reverse" : "row", width: '90%', pt: "100px", justifyContent: 'space-between', alignItems: 'center', maxWidth:'1050px', margin: 'auto' }}>
              {/* left part */}
              <Grid2 item xs={6}>
                <Stack direction="column" sx={{ textAlign: 'left' }} spacing={4}>
                  <Typography sx={{ fontWeight: 'bold', fontSize: isMobile ? 30 : 60, width: isS ? '100%' : 650, justifyItems: 'left', fontFamily: 'Afacad', lineHeight: 0.9 }}>{"Commandez et suivez vos transports sanitaires de façon simple et sécurisée"}</Typography>
                  <Typography sx={{ fontWeight: 'bold', fontSize: 24,lineHeight: 1, color: '#A6ACAF', width: isXS ? '100%' : 650, justifyItems: 'left', fontFamily: 'Afacad' }}>{"L'application sera bientôt disponible, restez informé en souscrivant à la newsletter."}</Typography>
                  <Stack direction="row" spacing={2}>
                  <FormControl fullWidth sx={{ width: 200}}>
                    <OutlinedInput
                        id="first_name"
                        type="text"
                        name="first_name"
                        placeholder='Entrez votre email'
                        sx={{
                          '& fieldset': {
                              borderRadius: 2,
                              border: 'none',
                          },
                          backgroundColor: 'white',
                          height: '40px'
                        }}
                        // onChange={((e) => {
                        //       setForm((cs) => ({
                        //             ...cs,
                        //             email: e.target.value
                        //         }));
                        //         setIsEmailUnfilled(false);
                        //     })
                        // }
                        inputProps={{}}
                    />
                      {/* {isEmailUnfilled && (
                          <FormHelperText error id="standard-weight-helper-text--register">
                              {'Veuillez entrer un email'}
                          </FormHelperText>
                      )} */}
                    </FormControl>
                    <Button variant='contained' disableElevation sx={{ fontSize: 18, fontWeight: 'bold', height: 40, width: 200, textTransform: 'lowercase', backgroundColor: '#1970B2', fontFamily: 'Afacad' }}>
                      Souscrire
                    </Button>
                  </Stack>
                </Stack>
              </Grid2>
              {/* Right part */}
              <Grid2 item xs={6} sx={{ mb: isL ? 6 : 0 }}>
                <Stack sx={{ alignItems: 'center' }}>
                  <img src={HeroImage} height="auto" width={ isL ? '100%' : 300} alt="logo" />
                </Stack>
              </Grid2>
            </Grid2>
            <Footer />
        </Box>
      );
}

export default Accueil;